import ApiHelper from './index';

const fetchSimilarStepsByTaskAndProcess = (task, process) => {
  return ApiHelper.get('organization/similar_steps', false, {
    task: task,
    process: process,
  });
};

const createSimilarStep = (payload) => {
  return ApiHelper.post('organization/similar_steps', payload, false);
};

const updateSimilarStep = (id, payload) => {
  return ApiHelper.patch(`organization/similar_steps/${id}/`, payload, false);
};

const deleteSimilarStep = (id) => {
  return ApiHelper.remove(`organization/similar_steps/${id}/`, false);
};

const getSimilarStep = (id) => {
  return ApiHelper.get(`organization/similar_steps/${id}/`, false);
};

export default {
  fetchSimilarStepsByTaskAndProcess,
  createSimilarStep,
  updateSimilarStep,
  deleteSimilarStep,
  getSimilarStep,
};
